// Cuerpo del reporte al CAD, compartido por cámara, bus y botón de pánico.
//
// Existe por dos razones concretas, las dos medidas:
//
// 1. `form.getItem()` devuelve TODOS los campos del formulario, también los que
//    el `onChange` del tipo ocultó. Sin recortar, quien empieza en «existente»
//    y cambia a «nueva» manda las dos parejas y el backend decide solo cuál
//    obedece. El legacy lo resolvía con `_.pick`; aquí se resuelve con una
//    función que además tiene prueba.
// 2. Un campo ausente NO produce un error legible: `POST bus/<id>/reportalert`
//    con `{}` devuelve `NullPointerException (KalanBusResource:160)` — medido
//    el 2026-09-25. Nombrar el hueco antes de salir es la diferencia entre
//    «Falta el Motivo» y «Ocurrió un error al reportar la alerta».
//
// Los dos modos existen en el backend de buses; para sensores, el modo
// «existente» está medido —el registro de alerta tiene columnas `folioCad` y
// `origenCad`, y es la MISMA tabla que la de buses: toda alerta de sensor lleva
// `busId: 0` junto a su `sensorId`— y el modo «nueva» se infiere de esa
// comunidad. Confirmarlo exigiría reportar una alerta real y crear un folio de
// verdad en el CAD, así que no se confirmó.

export const ORIGENES_CAD = ['C4', 'CERI', 'C4 MAZATLAN', 'C4 MOCHIS']

// Vacío, espacios o ausente son lo mismo para el backend: nada.
function vacio(v) {
  return v === null || v === undefined || String(v).trim() === ''
}

// → { body, falta: null } | { body: null, falta: '<etiqueta del campo>' }
// La etiqueta es la que el operador ve en el formulario, no el nombre del
// campo: un mensaje que dice «falta foliocad» obliga a traducir.
export function buildCadReportBody(item) {
  const it = item || {}

  if (it.tipo === 'nueva') {
    if (vacio(it.motivo)) return { body: null, falta: 'Motivo' }
    // La descripción sí puede ir vacía: el motivo es lo que identifica el
    // reporte, y obligar a escribir algo produce descripciones de relleno.
    return { body: { motivo: it.motivo, descripcion: it.descripcion || '' }, falta: null }
  }

  if (it.tipo === 'existente') {
    if (vacio(it.foliocad)) return { body: null, falta: 'Folio' }
    if (vacio(it.origen)) return { body: null, falta: 'Origen del folio' }
    return { body: { foliocad: it.foliocad, origen: it.origen }, falta: null }
  }

  // Elegir por el operador entre abrir un folio nuevo y asociarlo a uno que ya
  // existe no es un valor por defecto razonable en ninguna dirección.
  return { body: null, falta: 'Tipo' }
}
